import { render } from "./SettingsCheckPage.vue?vue&type=template&id=109f6bcc"
import script from "./SettingsCheckPage.vue?vue&type=script&lang=js"
export * from "./SettingsCheckPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__